import type { PreviewCustomValues } from '@faceup/report'
import { useNavigate } from '@faceup/router'
import { useEffect, useState } from 'react'
import { isFromAkutan } from '../utils/urls'

export type CustomValues = PreviewCustomValues
export const useCustomValues = () => {
  const [customValues, setCustomValues] = useState<CustomValues>()
  const navigate = useNavigate()
  // biome-ignore lint/correctness/useExhaustiveDependencies: State setters are stable and don't need to be in deps
  useEffect(() => {
    const messageHandler = (e: MessageEvent) => {
      // ignore everything without specified source
      // this accidentally handled e.g. React dev tools messages
      // setting state ad infinitum and leading to infinite renders
      if (
        isFromAkutan(e.origin) &&
        e.data.source === 'customization' &&
        typeof e.data === 'object'
      ) {
        setCustomValues(e.data)
      }
    }

    window.addEventListener('message', messageHandler)

    return () => window.removeEventListener('message', messageHandler)
  }, [navigate, setCustomValues])

  return customValues
}
